module.exports = __webpack_public_path__ + "img/huabei.1afde637.png";